// blog.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/Blog.css';
import { client } from '../sanityClient';


import blogImage from '../Asets/Blog.jpg';
import blog1 from '../Asets/Blog11.png';
import blog2 from '../Asets/Blog12.png';
import blog3 from '../Asets/blog13.jpeg';
import blog4 from '../Asets/blog16.jpeg';
import blog5 from '../Asets/blog22.jpg';
import blog6 from '../Asets/blog26.jpeg';
import blog7 from '../Asets/blog47.png';
import blog8 from '../Asets/blog88.jpeg';

/* New images added */
import blog99 from '../Asets/blog99.png';
import blog1010 from '../Asets/blog1010.png';
import blog1111 from '../Asets/blog1111.png';
import blog1212 from '../Asets/blog1212.png';

/* Added for blogs 13–17 */
import blog1313 from '../Asets/blog1313.png';
import blog1414 from '../Asets/blog1414.png';
import blog1515 from '../Asets/blog1515.png';
import blog1616 from '../Asets/blog1616.png';
import blog1717 from '../Asets/blog1717.png';

/* NEW: Blog 18–20 images */
import blog1818 from '../Asets/blog1818.png';
import blog1919 from '../Asets/blog1919.png';
import blog2020 from '../Asets/blog2020.png';

/* NEW: Blog 21–22 images */
import blog2121 from '../Asets/blog2121.png';
import blog2222 from '../Asets/blog2222.png';

/* NEW: Blog 23–24 images */
import blog2323 from '../Asets/blog2323.png';
import blog2424 from '../Asets/blog2424.png';

/* NEW: Blog 25–30 images */
import blog2525 from '../Asets/blog2525.png';
import blog2626 from '../Asets/blog2626.png';
import blog2727 from '../Asets/blog2727.png';
import blog2828 from '../Asets/blog2828.png';
import blog2929 from '../Asets/blog2929.png';
import blog3030 from '../Asets/blog3030.png';

/* NEW: Blog 31–33 images */
import blog3131 from '../Asets/blog3131.png';
import blog3232 from '../Asets/blog3232.png';
import blog3333 from '../Asets/blog3333.png';

/* NEW: Blog 34–35 images */
import blog3434 from '../Asets/blog3434.png';
import blog3535 from '../Asets/blog3535.png';

/* 🔥 NEW Blog 36–43 images */
import blog3636 from '../Asets/blog3636.png';
import blog3737 from '../Asets/blog3737.png';
import blog3838 from '../Asets/blog3838.png';
import blog3939 from '../Asets/blog3939.png';
import blog4040 from '../Asets/blog4040.png';
import blog4141 from '../Asets/blog4141.png';
import blog4242 from '../Asets/blog4242.png';
import blog4343 from '../Asets/blog4343.png';
import blog4444 from '../Asets/blog4444.jpg';
import blog4545 from '../Asets/blog4545.jpg';
import blog4646 from '../Asets/blog4646.jpg';

import Header from '../components/header';
import Footer from '../components/footer';
const Blog = () => {

const navigate = useNavigate();

const [sanityBlogs, setSanityBlogs] = useState([]);


useEffect(() => {

  client.fetch(`*[_type == "post"] | order(publishedAt desc){
    title,
    slug,
    publishedAt,
    "image": mainImage.asset->url,
    body
  }`)
  .then((data)=>{

    console.log("Sanity blogs:", data);

    const formatted = data.map((item,index)=>({
      id:100 + index,
      date:new Date(item.publishedAt).toDateString(),
      image:item.image,
      title:item.title,
      description:item.body,
     slug: item.slug?.current || "",
      isSanity:true
    }));

    setSanityBlogs(formatted);

  })
  .catch((err)=>{
    console.error("Sanity error:",err);
  });

},[]);


const blogs = [
       {
      id: 46,
      date: '31 December 2025',
      image: blog4646,
      title: 'The Benefits of Peer Learning in Preschool',
      description:
        'Early childhood is a crucial stage where children learn not only from teachers but also from one another.',
    },

    /* ===== NEW Blog 45 ===== */
    {
      id: 45,
      date: '29 December 2025',
      image: blog4545,
      title: '10 Questions Every Parent Must Ask Before Choosing a Preschool',
      description:
        'Choosing the right preschool is one of the most important decisions for parents. A strong preschool foundation shapes a child’s emotional',
    },

    /* ===== NEW Blog 44 ===== */
    {
      id: 44,
      date: '27 December 2025',
      image: blog4444,
      title: 'Boosting Early Learning Through Hands-On Activities in Preschool',
      description:
        'Early childhood is the most important phase for building a strong foundation for lifelong learning.',
    },

        /* ===== New Blog 43 ===== */
    {
      id: 43,
      date: '25 December 2025',
      image: blog4343,
      title: 'How Safe Classrooms Encourage Better Learning Outcomes',
      description:
        'A safe classroom is more than just a physical space—it is the foundation of effective learning in early childhood ',
    },

    /* ===== Blog 42 ===== */
    {
      id: 42,
      date: '23 December 2025',
      image: blog4242,
      title: 'How Preschools Shape Values in Early Childhood',
      description:
        'Early childhood is the foundation stage of life when children begin to understand the world around them. ',
    },

    /* ===== Blog 41 ===== */
    {
      id: 41,
      date: '21 December 2025',
      image: blog4141,
      title: 'Creativity in the Classroom: Why It Matters More Than Ever',
      description:
        'In today’s fast-changing world, creativity is no longer optional—it is essential. The ability to think creatively ',
    },

    /* ===== Blog 40 ===== */
    {
      id: 40,
      date: '19 December 2025',
      image: blog4040,
      title: 'The Role of Preschool in Building Emotional Strength and Resilience',
      description:
        'Emotional strength and resilience are life skills that help children handle challenges, manage emotions, and adapt to change ',
    },

    /* ===== Blog 39 ===== */
    {
      id: 39,
      date: '17 December 2025',
      image: blog3939,
      title: 'Helping Shy Kids Become More Confident in Preschool Environments',
      description:
        'Every child is unique. Some children walk into a classroom with excitement, while others need time ',
    },

    /* ===== Blog 38 ===== */
    {
      id: 38,
      date: '15 December 2025',
      image: blog3838,
      title:
        'Why Nutrition Matters in Early Childhood Development | Red School House',
      description:
        'Early childhood is a crucial stage of growth where the foundation for lifelong health, learning, and behavior is formed ',
    },

    /* ===== Blog 37 ===== */
    {
      id: 37,
      date: '13 December 2025',
      image: blog3737,
      title: 'The Importance of Hygiene Habits for Preschool Children',
      description:
        'Hygiene plays a crucial role in the healthy growth and development of preschool children. ',
    },

    /* ===== Blog 36 ===== */
    {
      id: 36,
      date: '11 December 2025',
      image: blog3636,
      title:
        'Best Christmas Poems for Kids: Short, Funny & Easy Rhymes to Celebrate',
      description:
        'Christmas is a magical season filled with lights, joy, family time, and festive fun. Kids especially love this time of the year ',
    },
    /* ===== New Blog 35 (09 Dec 2025) ===== */
    {
      id: 35,
      date: '09 December 2025',
      image: blog3535,
      title:
        'The Science Behind Play: Why Children Learn Best Through Fun',
      description:
        'Play is not just an activity — it is the natural language of childhood. Long before children learn to read or write, they learn through movement, touch ',
    },

    /* ===== New Blog 34 (07 Dec 2025) ===== */
    {
      id: 34,
      date: '07 December 2025',
      image: blog3434,
      title: 'How Sensory Play Shapes Brain Development in Preschoolers',
      description:
        'Early childhood is a powerful phase of brain development. During ages 2–6, a child’s brain forms millions of new connections every day.  ',
    },

    /* ===== New Blog 33 (05 Dec 2025) ===== */
    {
      id: 33,
      date: '05 December 2025',
      image: blog3333,
      title:
        'Top Reasons Parents Choose Red School House Vadodara for Preschool Education',
      description:
        'Choosing the right preschool is one of the most important decisions for any parent. ',
    },

    /* ===== New Blog 32 (03 Dec 2025) ===== */
    {
      id: 32,
      date: '03 December 2025',
      image: blog3232,
      title:
        'How Art and Music Enhance Child Development | Red School House Vadodara',
      description:
        'At Red School House Vadodara, we believe childhood is a journey of imagination, curiosity ',
    },

    /* ===== New Blog 31 (01 Dec 2025) ===== */
    {
      id: 31,
      date: '01 December 2025',
      image: blog3131,
      title:
        'How Preschool Activities Spark a Love for Learning in Young Minds',
      description:
        'The early years of a child’s life are filled with curiosity, imagination, and endless exploration. At this age, learning should feel exciting ',
    },

    /* ===== New Blog 30 (29 Nov 2025) ===== */
    {
      id: 30,
      date: '29 November 2025',
      image: blog3030,
      title:
        'Winter Morning Routine for Preschoolers | A Cozy Start to the Day',
      description:
        'As the temperature dips in Vadodara, leaving a warm, cozy bed becomes a challenge for all of us—especially our little ones!',
    },

    /* ===== New Blog 29 (27 Nov 2025) ===== */
    {
      id: 29,
      date: '27 November 2025',
      image: blog2929,
      title:
        'Why Mid-Career Professionals Are Choosing the Preschool Franchise Path',
      description:
        'There was a time when "success" meant climbing the corporate ladder, corner offices, and late-night conference calls. But today, a quiet revolution is happening.',
    },

    /* ===== New Blog 28 (25 Nov 2025) ===== */
    {
      id: 28,
      date: '25 November 2025',
      image: blog2828,
      title:
        'The Importance of a Safe and Nurturing Preschool Environment | Best Preschool in Harni, Vadodara',
      description:
        'A preschool is often a child’s first step into the world outside their home — a place where learning begins, friendships form, and confidence grows.',
    },

    /* ===== New Blog 27 (23 Nov 2025) ===== */
    {
      id: 27,
      date: '23 November 2025',
      image: blog2727,
      title:
        'Celebrating Animal Themes: Teaching Values Through Joyful Learning | Red School House Vadodara',
      description:
        'Children are naturally fascinated by animals — whether it’s a fluttering butterfly, a friendly dog, or a storybook lion.',
    },

    /* ===== New Blog 26 (21 Nov 2025) ===== */
    {
      id: 26,
      date: '21 November 2025',
      image: blog2626,
      title:
        'Developing Social Skills in Early Years – Red School House’s Proven Approach',
      description:
        'The early years of childhood are crucial, not only for academic learning but also for building meaningful life skills.',
    },

    /* ===== New Blog 25 (19 Nov 2025) ===== */
    {
      id: 25,
      date: '19 November 2025',
      image: blog2525,
      title:
        'How Red School House Blends Fun and Learning for Kindergarten Success',
      description:
        'Kindergarten is one of the most exciting learning stages in a child’s life. It’s where curiosity grows, imagination expands, and confidence begins to take shape.',
    },

    /* ===== New Blog 24 (17 Nov 2025) ===== */
    {
      id: 24,
      date: '17 November 2025',
      image: blog2424,
      title:
        'Why Emotional Intelligence Begins in Preschool | Best Preschool in Harni, Vadodara',
      description:
        'In today’s world, education is more than learning ABCs and numbers — it’s about helping children understand emotions, communicate better, and build meaningful relationships.',
    },

    /* ===== New Blog 23 (15 Nov 2025) ===== */
    {
      id: 23,
      date: '15 November 2025',
      image: blog2323,
      title:
        'Parent Involvement in Preschool: How Red School House Bridges Home and School | Best Preschool in Harni, Vadodara',
      description:
        'A child’s early education becomes stronger when parents and teachers work together. Preschool is not just a place where learning happens.',
    },

    /* ===== Existing Blog 22 ===== */
    {
      id: 22,
      date: '13 November 2025',
      image: blog2222,
      title:
        'The Role of Teachers in Shaping Early Childhood Learning | Red School House Vadodara',
      description:
        'The early years of a child’s education are full of curiosity, discovery, and growth.',
    },

    /* ===== Blog 21 ===== */
    {
      id: 21,
      date: '11 November 2025',
      image: blog2121,
      title:
        'Top Qualities Every Parent Should Look for in a Preschool | Red School House Guide',
      description:
        'Choosing the right preschool is one of the most important decisions a parent makes.',
    },

    /* ===== Blog 20 ===== */
    {
      id: 20,
      date: '07 November 2025',
      image: blog2020,
      title:
        'How Red School House Encourages Creativity and Confidence in Young Learners',
      description:
        'Every child is born curious — eager to explore, imagine, and express.',
    },

    /* ===== Blog 19 ===== */
    {
      id: 19,
      date: '06 November 2025',
      image: blog1919,
      title:
        'Early Childhood Education in Vadodara: Why the Right Start Matters Most',
      description:
        'A child’s early years are the building blocks of their future. These years shape how children think, learn, and interact with the world around them.',
    },

    /* ===== Blog 18 ===== */
    {
      id: 18,
      date: '05 November 2025',
      image: blog1818,
      title: 'Creating a Joyful Start to Every Child’s Learning Journey',
      description:
        'Every child’s first step into learning should be filled with joy, curiosity, and care.',
    },

    /* ===== Blog 17 ===== */
    {
      id: 17,
      date: '14 October 2025',
      image: blog1717,
      title: '10 Best Diwali Celebration Ideas for Schools in 2025',
      description: 'Diwali, the magnificent festival of lights...',
    },

    /* ===== Blog 16 ===== */
    {
      id: 16,
      date: '10 October 2025',
      image: blog1616,
      title:
        'Why a Low Teacher-Student Ratio Is a Key to Finding the Best Preschool in Vadodara',
      description:
        'Choosing the right preschool is one of the most significant decisions a parent can make.',
    },

    /* ===== Blog 15 ===== */
    {
      id: 15,
      date: '08 October 2025',
      image: blog1515,
      title:
        'Choosing the Right Preschool in Vadodara: A Checklist for Parents',
      description:
        'Selecting the first school for your child is a monumental decision.',
    },

    /* ===== Blog 14 ===== */
    {
      id: 14,
      date: '05 October 2025',
      image: blog1414,
      title:
        "The Power of Play: Nurturing Growth in Vadodara's Happiest Preschool",
      description: 'Watch a child build a towering castle with blocks...',
    },

    /* ===== Blog 13 ===== */
    {
      id: 13,
      date: '03 October 2025',
      image: blog1313,
      title:
        'The reason why quality preschools are on the rise among the working parents in India.',
      description: 'In the present-day world...',
    },

    /* ===== Blog 12 ===== */
    {
      id: 12,
      date: '01 October 2025',
      image: blog1212,
      title:
        'Why Family Matters: The Role of Loved Ones in Shaping Our Lives | Red School House Vadodara',
      description: 'At Red School House Vadodara, we believe...',
    },

    /* ===== Blog 11 ===== */
    {
      id: 11,
      date: '30 September 2025',
      image: blog1111,
      title: 'How AI is Changing the World of Learning',
      description: 'Education is no longer limited to chalkboards...',
    },

    /* ===== Blog 10 ===== */
    {
      id: 10,
      date: '28 September 2025',
      image: blog1010,
      title:
        'Lighting Up Diwali: Exploring Traditions and Art with Preschoolers | Red School House Vadodara',
      description: 'Diwali is more than just a festival of lights...',
    },

    /* ===== Blog 9 ===== */
    {
      id: 9,
      date: '24 September 2025',
      image: blog99,
      title:
        'Home to School: Road Safety Tips for Children | Red School House Vadodara',
      description:
        'Every parent knows that sending their little one to school...',
    },

    /* ===== Blog 8 ===== */
    {
      id: 8,
      date: '22 September 2025',
      image: blog8,
      title: 'Choosing the Best Preschool in Vadodara',
      description:
        'Choosing the right preschool is one of the most important decisions...',
    },

    /* ===== Blog 7 ===== */
    {
      id: 7,
      date: '18 August 2025',
      image: blog7,
      title:
        'Why Holistic Education Matters – The Red School House Vadodara',
      description:
        'Discover how Red School House Vadodara’s holistic approach...',
    },

    /* ===== Blog 6 ===== */
    {
      id: 6,
      date: '09 August 2025',
      image: blog6,
      title:
        'A Promise for Life: Fostering Sibling Bonds This Raksha Bandhan',
      description:
        'Celebrating Raksha Bandhan at Red School House Vadodara...',
    },

    /* ===== Blog 5 ===== */
    {
      id: 5,
      date: '07 August 2025',
      image: blog5,
      title: 'Why Redschool House is the Best School in Vadodara',
      description: 'Explore what makes Redschool House the best choice...',
    },

    /* ===== Blog 4 ===== */
    {
      id: 4,
      date: '05 August 2025',
      image: blog4,
      title: 'The Impact of Technology in Education',
      description: 'Explore how Redschool House Vadodara is leading...',
    },

    /* ===== Blog 3 ===== */
    {
      id: 3,
      date: '30 July 2025',
      image: blog3,
      title:
        'What Is an Educational Environment and Why It Matters for Your Child’s Growth',
      description:
        'Learn why the right educational environment is crucial...',
    },

    /* ===== Blog 2 ===== */
    {
      id: 2,
      date: '28 July 2025',
      image: blog2,
      title: 'Short Moral Stories for Kids in English (Ages 4–10)',
      description: '12 classic short moral stories...',
    },

    /* ===== Blog 1 ===== */
    {
      id: 1,
      date: '25 July 2025',
      image: blog1,
      title: 'Redschool House Vadodara – Best Play-Based Preschool',
      description: 'Discover Redschool House Vadodara...',
    },
  ];


  const allBlogs = [...sanityBlogs, ...blogs];

  return (
    <>
      <Header />

      {/* Hero Section */}
      <div className="blog-section">
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>  


        {/* Blog Cards */}
        <div className="blog-container">
          <h2 className="section-title">Our Latest Blogs</h2>
          <br />
          <div className="blog-cards">
        {allBlogs.map((blog) => (
         <div
  key={blog.id}
  className={`blog-card ${blog.id === 3 ? 'featured-blog' : ''}`}
>
                <div className="blog-date">{blog.date}</div>
                <img src={blog.image} alt={blog.title} className="blog-img" />
                <h3 className="blog-heading">{blog.title}</h3>
                <p className="blog-desc">{blog.description}</p>
                <button
                  className="read-btn"
                  onClick={() => {

                    
    if (blog.isSanity) {
      navigate(`/blog/${blog.slug}`);
      return;
    }

                    if (blog.id === 1) {
                      navigate(
                        '/blog/RedHouseSchoolVadodara–BestPlay-BasedPreschool'
                      );
                    } else if (blog.id === 2) {
                      navigate(
                        '/blog/Short_Moral_Stories_for_Kids_in_English'
                      );
                    } else if (blog.id === 3) {
                      navigate(
                        "/blog/What_Is_an_Educational_Environment_and_Why_It_Matters_for_Your_Child’s_Growth"
                      );
                    } else if (blog.id === 4) {
                      navigate('/blog/The_Impact_of_Technology_in_Education');
                    } else if (blog.id === 5) {
                      navigate(
                        '/blog/Why_Red_House_School_is_the_Best_School_in_Vadodara'
                      );
                    } else if (blog.id === 6) {
                      navigate(
                        '/blog/A_Promise_for_Life_Fostering_Sibling_Bonds_This_Raksha_Bandhan'
                      );
                    } else if (blog.id === 7) {
                      navigate(
                        '/blog/Why_Holistic_Education_Matters_–_The_Red_House_Approach'
                      );
                    } else if (blog.id === 8) {
                      navigate('/blog/choosing_the_best_preschool_in_vadodara');
                    } else if (blog.id === 9) {
                      navigate(
                        '/blog/Home_to_School:Road_Safety_Tips_for_Children|_Red_School_House_Vadodara'
                      );
                    } else if (blog.id === 10) {
                      navigate(
                        '/blog/Lighting_Up_Diwali:Exploring_Traditions_and_Art_with_Preschoolers|_Red_School_House_Vadodara'
                      );
                    } else if (blog.id === 11) {
                      navigate(
                        '/blog/How_AI_is_Changing_the_World_of_Learning'
                      );
                    } else if (blog.id === 12) {
                      navigate(
                        '/blog/Why_Family_Matters:The_Role_of_Loved_Ones_in_Shaping_Our_Lives|_Red_School_House_Vadodara'
                      );
                    } else if (blog.id === 13) {
                      navigate(
                        '/blog/The_reason_why_quality_preschools_are_on_the_rise_among_the_working_parents_in_India'
                      );
                    } else if (blog.id === 14) {
                      navigate(
                        "/blog/The_Power_of_Play:_Nurturing_Growth_in_Vadodara's_Happiest_Preschool"
                      );
                    } else if (blog.id === 15) {
                      navigate(
                        '/blog/Choosing_the_Right_Preschool_in_Vadodara:_A_Checklist_for_Parents'
                      );
                    } else if (blog.id === 16) {
                      navigate(
                        '/blog/Why_a_Low_Teacher-Student_Ratio_Is_a_Key_to_Finding_the_Best_Preschool_in_Vadodara'
                      );
                    } else if (blog.id === 17) {
                      navigate(
                        '/blog/10_Best_Diwali_Celebration_Ideas_for_Schools_in_2025'
                      );
                    } else if (blog.id === 18) {
                      navigate(
                        '/blog/Creating_a_Joyful_Start_to_Every_Childs_Learning_Journey'
                      );
                    } else if (blog.id === 19) {
                      navigate(
                        '/blog/Early_Childhood_Education_in_Vadodara:_Why_the_Right_Start_Matters_Most'
                      );
                    } else if (blog.id === 20) {
                      navigate(
                        '/blog/How_Red_School_House_Encourages_Creativity_and_Confidence_in_Young_Learners'
                      );
                    } else if (blog.id === 21) {
                      navigate(
                        '/blog/Top_Qualities_Every_Parent_Should_Look_for_in_a_Preschool'
                      );
                    } else if (blog.id === 22) {
                      navigate(
                        '/blog/The_Role_of_Teachers_in_Shaping_Early_Childhood_Learning'
                      );
                    } else if (blog.id === 23) {
                      navigate('/blog/Parent_Involvement_in_Preschool');
                    } else if (blog.id === 24) {
                      navigate(
                        '/blog/Why_Emotional_Intelligence_Begins_in_Preschool'
                      );
                    } else if (blog.id === 25) {
                      navigate(
                        '/blog/How_Red_School_House_Blends_Fun_and_Learning_for_Kindergarten_Success'
                      );
                    } else if (blog.id === 26) {
                      navigate(
                        '/blog/Developing_Social_Skills_in_Early_Years_Red_School_Houses_Proven_Approach'
                      );
                    } else if (blog.id === 27) {
                      navigate(
                        '/blog/Celebrating_Animal_Themes_Teaching_Values_Through_Joyful_Learning'
                      );
                    } else if (blog.id === 28) {
                      navigate(
                        '/blog/The_Importance_of_a_Safe_and_Nurturing_Preschool_Environment'
                      );
                    } else if (blog.id === 29) {
                      navigate(
                        '/blog/Why_Mid-Career_Professionals_Are_Choosing_the_Preschool_Franchise_Path'
                      );
                    } else if (blog.id === 30) {
                      navigate(
                        '/blog/Winter_Morning_Routine_for_Preschoolers_A_Cozy_Start_to_the_Day'
                      );
                    } else if (blog.id === 31) {
                      navigate(
                        '/blog/How_Preschool_Activities_Spark_a_Love_for_Learning_in_Young_Minds'
                      );
                    } else if (blog.id === 32) {
                      navigate(
                        '/blog/How_Art_and_Music_Enhance_Child_Development'
                      );
                    } else if (blog.id === 33) {
                      navigate(
                        '/blog/Top_Reasons_Parents_Choose_Red_School_House_Vadodara_for_Preschool_Education'
                      );
                    } else if (blog.id === 34) {    
                      navigate(
                        '/blog/How_Sensory_Play_Shapes_Brain_Development_in_Preschoolers'
                      );
                    } else if (blog.id === 35) {
                      navigate(
                        '/blog/The_Science_Behind_Play_Why_Children_Learn_Best_Through_Fun'
                      );
                    }
                    else if (blog.id === 36) {
                      navigate('/blog/Best_Christmas_Poems_for_Kids');
                    } else if (blog.id === 37) {
                      navigate('/blog/The_Importance_of_Hygiene_Habits_for_Preschool_Children');
                    } else if (blog.id === 38) {
                      navigate('/blog/Why_Nutrition_Matters_in_Early_Childhood_Development');
                    }
                    else if (blog.id === 39) {
                      navigate('/blog/Helping_Shy_Kids_Become_More_Confident_in_Preschool');
                    } else if (blog.id === 40) {
                      navigate('/blog/The_Role_of_Preschool_in_Building_Emotional_Strength');
                     } 
                     else if (blog.id === 41) {
                      navigate('/blog/Creativity_in_the_Classroom_Why_It_Matters');
                    } else if (blog.id === 42) {
                      navigate('/blog/How_Preschools_Shape_Values_in_Early_Childhood');
                    }
                     else if (blog.id === 43) {
                      navigate('/blog/How_Safe_Classrooms_Encourage_Better_Learning_Outcomes');
                    }

                      else if (blog.id === 44) {
                      navigate('/blog/Boosting_Early_Learning_Through_Hands-On_Activities');
                    } else if (blog.id === 45) {
                      navigate('/blog/10_Questions_Every_Parent_Must_Ask_Before_Choosing_a_Preschool');
                    } else if (blog.id === 46) {
                      navigate('/blog/The_Benefits_of_Peer_Learning_in_Preschool');
                    }
                  }
                }
                >
                  Read More
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog;      